import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  CalendarRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import SharedToolbar from '../../../../shared/shared-toolbar-latest';
import CreateButton from '../../../../shared/buttons/create-button';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button';
interface FeaturesGridToolbarProps {
  calendarRoles: string[];
  setOpenCreateFeature: Dispatch<SetStateAction<boolean>>;
}

export default function FeaturesGridToolbar({
  calendarRoles,
  setOpenCreateFeature,
}: FeaturesGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      noColumn
      noFilter
      primaryButtons={
        <CreateButton
          onClick={() => setOpenCreateFeature(true)}
          disabled={
            !isAbleToSeeUIElement(
              calendarRoles,
              CalendarRoles.CreateFeatures.value
            )
          }
          label="Add Feature"
        />
      }
      secondaryButtons={
        <SharedIconButton
          variant="refresh"
          onClick={() => {
            void queryClient.invalidateQueries({
              queryKey: ['Features'],
            });
          }}
          tooltipLabel="Refresh"
        />
      }
    />
  );
}
